/**
 * Iter59 — ActividadTab extraído de ClienteDetalle.jsx (tab solo-lectura).
 */
import React from 'react';
import { Card } from '../ui/card';
import { Activity } from 'lucide-react';

export const ActividadTab = ({ actividad, ActividadItem }) => (
  <Card className="p-6 border-ink-200 bg-white" data-testid="tab-actividad-content">
    <div className="flex items-center justify-between mb-6">
      <div>
        <h3 className="font-heading font-semibold text-ink-900 flex items-center gap-2">
          <Activity className="w-5 h-5 text-brand-600" /> Actividad reciente
        </h3>
        <p className="text-xs text-ink-500 mt-1">Últimas 3 acciones registradas sobre este cliente.</p>
      </div>
    </div>
    {actividad.length === 0 ? (
      <p className="text-sm text-ink-400 text-center py-8">Sin actividad aún. Edita la ficha o añade contactos para generar registros.</p>
    ) : (
      <ul className="space-y-4" data-testid="actividad-lista">
        {actividad.map((a, i) => <ActividadItem key={i} item={a} />)}
      </ul>
    )}
  </Card>
);

export default ActividadTab;
